/**
 * FunnelToolbar — nome do funil + Cancelar / Salvar / ⋯
 */
import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import Input from '../../../../components/ui/Input';
import Label from '../../../../components/ui/Label';
import { Button } from '../../../../components/ui/Button';
import ActionMenu from '../../../../components/shared/ActionMenu';
import Spinner from '../../../../components/ui/Spinner';

interface FunnelToolbarProps {
    funnelName: string;
    onNameChange: (value: string) => void;
    onTitleBlur: () => void;
    onCancel: () => void;
    onSave: () => void;
    isSubmitting: boolean;
    canSave: boolean;
    isEditMode: boolean;
    onDuplicate: () => void;
    onDelete: () => void;
}

const ACTION_BTN = 'min-h-9 flex-1 touch-manipulation sm:flex-none';

const FunnelToolbar: React.FC<FunnelToolbarProps> = ({
    funnelName,
    onNameChange,
    onTitleBlur,
    onCancel,
    onSave,
    isSubmitting,
    canSave,
    isEditMode,
    onDuplicate,
    onDelete,
}) => {
    const saveLabel = isEditMode ? 'Salvar alterações' : 'Criar funil';

    return (
        <header className="flex shrink-0 flex-col gap-s3 sm:flex-row sm:items-center sm:justify-between sm:gap-s4">
            <div className="flex min-w-0 w-full items-center gap-s2 sm:w-auto sm:max-w-xs">
                <Label htmlFor="funnel-name" className="shrink-0">
                    Nome do funil
                </Label>
                <Input
                    id="funnel-name"
                    value={funnelName}
                    onChange={(event) => onNameChange(event.target.value)}
                    onBlur={onTitleBlur}
                    placeholder="Nome do funil"
                    aria-label="Nome do funil"
                    inputSize="sm"
                    containerClassName="min-w-0 w-full sm:w-44"
                />
            </div>

            <div className="flex flex-wrap items-center gap-s2 sm:justify-end">
                <Button
                    type="button"
                    variant="secondary"
                    onClick={onCancel}
                    disabled={isSubmitting}
                    className={ACTION_BTN}
                >
                    Cancelar
                </Button>
                <Button
                    type="button"
                    onClick={onSave}
                    disabled={isSubmitting || !canSave}
                    className={ACTION_BTN}
                >
                    {isSubmitting ? (
                        <>
                            <Spinner size="sm" color="white" />
                            Salvando...
                        </>
                    ) : (
                        saveLabel
                    )}
                </Button>
                {isEditMode && (
                    <ActionMenu
                        actions={[
                            {
                                label: 'Duplicar funil',
                                icon: <AppIcon name="duplicate" className="size-4" />,
                                onClick: onDuplicate,
                            },
                            {
                                label: 'Excluir funil',
                                icon: <AppIcon name="trash" className="size-4" />,
                                onClick: onDelete,
                                variant: 'danger',
                            },
                        ]}
                    />
                )}
            </div>
        </header>
    );
};

export default FunnelToolbar;
